import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TAccount  {
    _originalTypeClassName = "zERP.BO.TAccount";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TAccount.translate = translateService;
}
this.ChartOfAccount = new Domain.Account();
this.AccountID = null;
this.OpeningDebit = null;
this.OpeningCredit = null;
this.OpeningBalance = null;
this.YearToDateDebit = null;
this.YearToDateCredit = null;
this.YearToDateBalance = null;
this.GLYearToDateDebit = null;
this.GLYearToDateCredit = null;
this.GLYearToDateBalance = null;
this.Budget = null;
this.hasConsolidation = false;
this.hasRamification = false;
this.hasAllocation = false;
this._key = this.AccountID = 0; 
}

static translate: TranslateService;
_key: any;
private _AccountID:any;
get AccountID(): any {
    return this._AccountID;
  }
set AccountID(value: any) {
    this._AccountID = value;
    this._key = value;
  }
OpeningDebit:any;
OpeningCredit:any;
OpeningBalance:any;
YearToDateDebit:any;
YearToDateCredit:any;
YearToDateBalance:any;
GLYearToDateDebit:any;
GLYearToDateCredit:any;
GLYearToDateBalance:any;
Budget:any;
hasConsolidation:any;
hasRamification:any;
hasAllocation:any;
ChartOfAccount:any;
static setChartOfAccount = ($this, value) => {
var oldValue = $this.ChartOfAccount;
$this.ChartOfAccount = value;
if (value != null) {
if (oldValue != null && oldValue.TAccount != null) { oldValue.TAccount = null; }
if ($this.ChartOfAccount.TAccount !== $this) {
Domain.Account.setTAccount(value, $this);
}
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AccountID == null || $this.AccountID == 0;
            }


}